export default __webpack_public_path__ + "static/media/BannerTitle.9c09de48.png";